<div class="container py-4 animated fadeIn" >
  <h2>
    Buscar: {{ termino | uppercase}}
  </h2>
  <hr>

  <div class='alert' *ngIf="proyecto.length == 0" >
        <p>
        No existe el termino: {{termino}} en la base de datos... :(
        </p>
  </div>
  <div class='tarjeta my-4' *ngFor='let proyecto of proyecto; let i = index'>
  <h1 class="titulo">
      {{ proyecto.nombre }}
    <small class="fecha">
    </small>
  </h1>

  
  <div class="row" >
    <div class="col-12 col-lg-6">
      <img [src]="proyecto.img" class="img-thumbnail" alt="proyecto.nombre">
    </div>
    <div class="col-12 col-lg-6 descripcion my-3">
      <p>
      {{ proyecto.descripcion }}
      </p>
    <br>
    <br>
    <a [routerLink]="['/galeria']"  class='btn btnRegresar'><i class="fas fa-arrow-left"></i> Atras</a>
    <a href="{{ proyecto.direccion }}" target="_blank" class='btn btnOnline'><i class="fas fa-globe-americas"></i> Online</a>
    </div>
  </div>
  </div>
</div>

